import {
  Badge,
  ChakraBox,
  ChakraFlex,
  ChakraTab,
  ChakraTabList,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';

import { GlobalSearchTabs, GlobalSearchTabsCollection } from './constants';

const { label: labelStyle } = EquipUITheme.typography;

const TAB_LIST_HEIGHT = 42;

type TabListProps = {
  id: string;
  resultCounts: Record<GlobalSearchTabs, number>;
};

const TabList = ({ id, resultCounts }: TabListProps) => {
  const TOP_LEVEL_ID = `${id}__tab-list`;

  return (
    <ChakraTabList
      background="neutral.background.secondary"
      borderRadius="29px"
      height={`${TAB_LIST_HEIGHT}px`}
      id={TOP_LEVEL_ID}
      padding="6px"
      width="fit-content"
    >
      {Object.entries(GlobalSearchTabsCollection).map(([tab, { label }]) => (
        <ChakraTab
          _selected={{
            backgroundColor: 'primary.100',
            boxShadow: 'none',
            color: 'white',
          }}
          color="neutral.secondary"
          id={`${TOP_LEVEL_ID}__${tab}-tab`}
          key={tab}
          lineHeight="16.8px"
          padding="6.5px 12px"
        >
          <ChakraFlex align="center" justify="space-between">
            <ChakraText
              {...labelStyle}
              id={`${TOP_LEVEL_ID}__${tab}-tab__label`}
              paddingRight="4px"
            >
              {label}
            </ChakraText>
            <ChakraBox maxHeight="22px">
              <Badge
                badgeColor="tertiary.marigold.base"
                fontSize="10px"
                id={`${TOP_LEVEL_ID}__${tab}-tab__counter`}
                margin="0"
              >
                {resultCounts[tab]}
              </Badge>
            </ChakraBox>
          </ChakraFlex>
        </ChakraTab>
      ))}
    </ChakraTabList>
  );
};

export default TabList;
